import styled from 'styled-components';
import { Text } from '../Typography';

export const Hint = styled(Text)`
  font-size: 10px;
  margin-top: 4px;
`;
